var $5e997db6ea0d10f6$exports = {};
$5e997db6ea0d10f6$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Farvev\xE6lger",
  "colorSwatch": "farvepr\xF8ve",
  "transparent": "gennemsigtig",
  "twoDimensionalSlider": "2D-skyder"
};
export { $5e997db6ea0d10f6$exports as default };